import { Button, Modal, Paper, Slide } from '@material-ui/core'

import { getTranslate } from '../../localization'
// import { JobDetailsModalTable } from './JobDetailsModalTable'
import { JobsTable } from './JobsTable'
// import UserAPIKeyRowSkeleton from './UserAPIKeyRow.skeleton'
import useStyles from './styles/jobDetails.styles'

interface ChannelAPIKeyModalProps {
  isOpen: boolean
  onClose: () => void
}

const JobsTableModal: React.FC<ChannelAPIKeyModalProps> = ({
  isOpen,
  onClose
}) => {
  const classes = useStyles()

  return (
    <Modal open={isOpen} onClose={onClose} className={classes.modal}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <JobsTable />
          <div className={classes.buttonsContainer}>
            <Button
              onClick={() => onClose()}
              variant="contained"
              color="primary"
              className={classes.deleteButton}>
              {getTranslate('Close')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default JobsTableModal
